import { ticketCallPresentation } from '../telephony/TicketCallHistory';
import type { BrowserCall } from '../telephony/types';
import { userHasAnyRole } from '../roles';
import type { CompanyNote } from './types';

export function clientCallPresentation(call: BrowserCall) {
  const base = ticketCallPresentation(call);
  const contact = String(call.contact_name || '').trim();
  const company = String(call.company_name || '').trim();
  const party = [contact, company].filter(Boolean).join(' · ') || 'Клиент не определён';
  const ticketNumber = String(call.ticket_display_number || '').trim();
  const ticketSubject = String(call.ticket_subject || '').trim();
  return {
    ...base,
    party,
    ticket: [ticketNumber, ticketSubject].filter(Boolean).join(' · '),
    comment: String(call.result_comment || '').trim(),
  };
}

export function compactCallPartyPresentation(call?: BrowserCall | null) {
  const number = call
    ? String(call.direction === 'INBOUND' ? call.from_number || call.to_number || '' : call.to_number || call.from_number || '')
    : '';
  const contact = String(call?.contact_name || '').trim();
  const company = String(call?.company_name || '').trim();
  return {
    title: contact || number || 'Встроенный телефон',
    number,
    company: company || 'Компания не определена',
    matched: Boolean(contact || company),
  };
}

export function companyNotePresentation(note: CompanyNote) {
  const wasEdited = Boolean(note.updated_at && note.created_at && note.updated_at !== note.created_at);
  return {
    author: String(note.author_name || '').trim() || 'Сотрудник',
    body: String(note.body || '').trim(),
    importantLabel: note.is_important ? 'Важная заметка' : 'Заметка',
    auditLabel: wasEdited
      ? `Изменил: ${String(note.updated_by_name || note.author_name || 'сотрудник').trim()}`
      : '',
  };
}

export function mayEditCompanyNote(
  note: Pick<CompanyNote, 'author_user_id'>,
  user?: { id?: string | null; userType?: string | null; role?: string | null; roles?: readonly string[] | null } | null,
): boolean {
  if (!user || !userHasAnyRole(user, ['ADMIN', 'MANAGER', 'DISPATCHER', 'EXECUTOR'])) return false;
  return user.id === note.author_user_id || userHasAnyRole(user, ['ADMIN', 'MANAGER']);
}

export function formatClientHistoryDate(value?: string | null): string {
  if (!value) return 'Время не указано';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'Время не указано';
  return new Intl.DateTimeFormat('ru-RU', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}
